import {
    IAudiencia,
    IComunicadoEmMassa,
} from "../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import {
    CadastrarAudienciaService,
    ComunicadoEmMassaService,
    DeletarAudienciaService,
    EditarAudienciaService,
    GetsAudienciaService,
} from "../../../Services/Automacao/Audiencia/AudienciaServices";
import { Controller } from "../../Controller";

export async function GetsAudienciaController() {
    return Controller(GetsAudienciaService());
}

export async function CadastrarAudienciaController(requestBody: IAudiencia) {
    return Controller(CadastrarAudienciaService(requestBody));
}

export async function EditarAudienciaController(requestBody: IAudiencia) {
    return Controller(EditarAudienciaService(requestBody));
}

export async function DeletarAudienciaController(idAudiencia: number) {
    return Controller(DeletarAudienciaService(idAudiencia));
}

export async function ComunicadoEmMassaController(
    tipoComunicação: "Email" | "WhatsApp" | "SMS",
    requestBody: IComunicadoEmMassa
) {
    return Controller(ComunicadoEmMassaService(tipoComunicação, requestBody));
}
